<template>
  <div v-if="show">
    <table class="grid">
      <tr>
        <td class="col1 text-top">
          <span class="detail-title">Dettaglio:<br><em>{{ channel.name }}</em></span>
        </td>
        <td class="report-arrow text-top"><img class="mt-20" src="/static/report/arrow.png"></td>
        <td class="col2 text-top">
          <div class="pie-wrap2 mt-20">
            <apexchart type="pie" :options="pie_options" :series="pie_data" />
          </div>
        </td>
        <td class="col3">
          <b-table class="last-bold" :fields="fields" :items="channel.items">
            <template slot="color" slot-scope="row">
              <span v-if="! row.item.isTotal" class="legend" :style="{ color: $store.state.colors[row.index] }">■</span>
            </template>
          </b-table>
        </td>
      </tr>
    </table>

    <div style="width: 940px;">
      <apexchart type="bar" :options="bar_options" :series="bar_series" />
    </div>

    <ripartizione-charts :index="index" :vector="vector" :month="month" :siteGuid="siteGuid" :channel="channel" v-for="channel in subchannels" :key="channel.code" />
  </div>
</template>

<script>
var moment = require('moment');

export default {
  name: "RipartizioneCharts",
  props: ['channel', 'siteGuid', 'month', 'index', 'vector'],

  data() {
    return {
      show: false,
      pie_options: {
        colors: this.$store.state.colors,
        chart: {
          animations: { enabled: false },
          width: 240,
        },
        labels: [],
        legend: { show: false }
      },
      currentYear: 0,
      fields: [{ key: "color", label: "" }, { key: "name", label: "" }, { key: "value", label: this.vectorMu }],
      c_index: 1,
      pie_data: [],
      allChannels: [],
      bar_options: {
        colors: this.$store.state.colors,
        chart: {
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          },
          stacked: true,
          height: 200,
          width: 940,
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            formatter: (v) => this.f(v)
          }
        },
      },
      bar_series: [],
      subchannels: []
    }
  },

  mounted() {
    this.currentYear = parseInt(moment(this.month, 'MM-YYYY').format('YYYY'))

    let params = {
      fromMonth: '01-' + this.currentYear,
      toMonth: '12-' + this.currentYear,
      siteGuid: this.siteGuid,
      vector: this.vector,
      parent: this.channel.code
    }

    this.allChannels = this.$store.state.user.sites.find(s => s.guid == this.siteGuid).channels

    this.$store.dispatch('charts/monthlyTepCategory', params, { root: true }).then( (response) => {
      if(! response.data) {
        this.$notify({
          type: "error",
          text: response.message,
          title: 'Errore',
        });
        return;
      }

        let data = response.data;

      if(data.values.length > 0) {
        this.show = true
        this.channel.index = this.c_index++

        let pie_options = _.cloneDeep(this.pie_options)
        pie_options.labels = data.channels
        this.pie_options = pie_options

        var curData = _.filter(data.values, v => v[1] == this.month)

        var total = 0
        curData.forEach(v => {
          this.pie_data.push(v[2])
          total += v[2]
        })

        this.channel.items = curData.map(v => {
          return {
            name: v[0],
            value: this.f(v[2])
          }
        })

        curData.forEach(v => {
          let sub = this.allChannels.find(c => c.name == v[0])
          if(sub)
            this.subchannels.push(sub)
        })

        this.channel.items.push({
          name: "Totale",
          value: this.f(total),
          isTotal: true
        })

        this.bar_series = data.channels.map(channel => { return { name: channel, data: [] } })

        let bar_options = _.cloneDeep(this.bar_options)
        for(let i=1; i<=12; i++) {
          var month = i.toString().padStart(2, "0") + "-" + this.currentYear
          bar_options.xaxis.categories.push(moment(month, "MM-YYYY").format("MMM"))

          data.channels.forEach(channel => {
            var item = data.values.find(e => e[1] == month && e[0] == channel)
            var serie = this.bar_series.find(s => s.name == channel)
            serie.data.push(item[2] ? item[2] : null)
          })
        }
        this.bar_options = bar_options
      }
    })
  },
  methods: {
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
  },
  computed: {
    vectorName() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).name
    },
    vectorMu() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).mu
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Report/G1_RipartizioneCharts.vue